import React from 'react';

import {getLayeredIcon} from '../../../../utils/common'

export default class Checkbox extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            checked: false
        }
    }

    componentWillReceiveProps(nextProps){
        let {checked} = nextProps;
        this.setState({checked:checked})
    }

    toggleCheckbox=()=>{
        let {onClick, checked} = this.props;

        if(checked==undefined) {
            this.setState((prevState) => {
                return {
                    checked: !prevState.checked
                }
            });
        }

        onClick && onClick();
    }

    render(){
        return (<span tabIndex="0" role="checkbox" className='checkbox' onClick={this.toggleCheckbox}
        onKeyPress={this.toggleCheckbox} style={{cursor:'pointer', 'vertical-align': 'top'}}>
            {this.state.checked ? getLayeredIcon("icon-checkboxes-01") : <i className="icon-checkboxes-02" />}
        </span>)
    }
}
